<template>
  <section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: '/servers' }"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
    </header>
    <heim-card>
      <header>
        <h1>{{ $t('edit') }} {{ $t('server') }}</h1>
      </header>
      <main>
        <form @submit.prevent="handleForm">
          <div class="row">
            <span class="label">{{ $t('server') }}</span>
            <div class="inputs">
              <heim-input :label="$t('name') + ' *'" name="name" placeholder="e.g : Server 1" v-model="server.name" v-validate="'required'"></heim-input>
               <span v-show="errors.has('name')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('name') }}</span>
              <heim-input :label="$t('ip') + ' *'" name="ip" placeholder="0.0.0.0" v-model="server.ip" v-validate="'required|ip'"></heim-input>
               <span v-show="errors.has('ip')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('ip') }}</span>
              <heim-textarea :label="$t('description') + ' *'" name="description" :placeholder="$t('serverDescription')" v-model="server.description" v-validate="'required'"></heim-textarea>
               <span v-show="errors.has('description')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('description') }}</span>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('cpu') }}</span>
            <div class="inputs">
              <heim-input :label="$t('cpuThreshold') + ' *'" name="cpu_threshold" placeholder="90" v-model="server.cpu_threshold" v-validate="'required'"></heim-input>
               <span v-show="errors.has('cpu_threshold')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('cpu_threshold') }}</span>
              <div class="toggle-box"><span class="label">{{ $t('isEnabled') }}</span><heim-toggle-button uid="cpu_alert" name="cpu_alert" v-model="server.cpu_alert"></heim-toggle-button></div>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('memory') }}</span>
            <div class="inputs">
              <heim-input :label="$t('memoryThreshold') + ' *'" name="mem_threshold" placeholder="90" v-model="server.mem_threshold" v-validate="'required'"></heim-input>
               <span v-show="errors.has('mem_threshold')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('mem_threshold') }}</span>
              <div class="toggle-box"><span class="label">{{ $t('isEnabled') }}</span><heim-toggle-button uid="mem_alert" name="mem_alert" v-model="server.mem_alert"></heim-toggle-button></div>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('drive') }}</span>
            <div class="inputs">
              <heim-input :label="$t('diskThreshold') + ' *'" name="drive_threshold" placeholder="90" v-model="server.drive_threshold" v-validate="'required'"></heim-input>
               <span v-show="errors.has('drive_threshold')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('drive_threshold') }}</span>
              <div class="toggle-box"><span class="label">{{ $t('isEnabled') }}</span><heim-toggle-button uid="drive_alert" name="drive_alert" v-model="server.drive_alert"></heim-toggle-button></div>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('monitoring') }}</span>
            <div class="inputs">
              <heim-input
                :label="$t('pingInterval') + ' (ms)*'"
                name="interval"
                type="number"
                placeholder="300000"
                v-model="server.interval"
                required="required"
              ></heim-input>
              <heim-input
                :label=" $t('errorRecurrence')"
                name="nb_occurence"
                type="number"
                placeholder="2"
                v-model="server.nb_occurence"
              ></heim-input>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('provider') + ' *' }}</span>
            <div class="inputs">
              <heim-select
                :data="providers"
                label-key="name"
                value-key="id"
                v-model="server.provider_id"
                required="required"
              ></heim-select>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('hosting') }}</span>
            <div class="inputs">
              <heim-input :label="$t('costServer') + ' (€)'" name="cost_server" type="number" v-model="server.cost_server" step="0.01"></heim-input>
              <heim-input :label="$t('costHardDisk') + ' (€)'" name="cost_hard_disk" type="number" v-model="server.cost_hard_disk" step="0.01"></heim-input>
              <heim-input :label="$t('auxiliaryCost') + ' (€)'" name="auxiliary_cost" type="number" v-model="server.auxiliary_cost" step="0.01"></heim-input>
              <heim-input :label="$t('rds') + ' (€)'" name="rds" type="number" v-model="server.rds" step="0.01"></heim-input>
              <heim-input :label="$t('backup') + ' (€)'" name="backup" type="number" v-model="server.backup" step="0.01"></heim-input>
              <heim-input :label="$t('bandwidth') + ' (€)'" name="bandwidth" type="number" v-model="server.bandwidth" step="0.01"></heim-input>
              <heim-input :label="$t('support') + ' (€)'" name="support" type="number" v-model="server.support" step="0.01"></heim-input>
              <heim-input :label="$t('ipElastic')" name="ip_elastic" type="text" v-model="server.ip_elastic"></heim-input>
              <heim-input :label="$t('typeServer')" name="type_server" v-model="server.type_server"></heim-input>
              <heim-input :label="$t('nbCPU')" name="nb_cpu" type="number" v-model="server.nb_cpu"></heim-input>
              <heim-input :label="$t('nbRAM')" name="nb_ram" type="number" v-model="server.nb_ram"></heim-input>
              <heim-input :label="$t('diskSpace') + $t('go_')" name="disk_space" v-model="server.disk_space"></heim-input>
              <div class="toggle-box">
                 <span class="label">{{ $t('reservedInstance') }}</span>
                 <heim-toggle-button uid="hosting_reserved" name="hosting_reserved" v-model="server.hosting_reserved"></heim-toggle-button>
              </div>
              <div class="heim-input">
                <span class="label">{{ $t('birthday') }}</span>
                <datepicker 
                type="date"
                name="hosting_birthday"
                input-class="paper-input"
                wrapper-class="date-input"
                v-model="server.hosting_birthday"
                placeholder="Select Date"
                ></datepicker>
              </div>
              <div class="heim-input">
                <span class="label">{{ $t('localization') }}</span>
                <places
                  name="hosting_localization"
                  v-model="server.hosting_localization"
                  placeholder="Localization"
                  @change="val => { form.country.data = val }"
                >
                </places>
              </div>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('isEnabled') }}</span>
            <div class="inputs">
              <heim-toggle-button uid="enabled" name="enabled" v-model="server.enabled"></heim-toggle-button>
            </div>
          </div>
          <footer>
            <heim-button :disabled="errors.any()" type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
    <section class="user-section">
      <div class="server-users">
        <heim-card>
          <header>
            <h1>{{ $t('editServerAdministrators') }}</h1>
          </header>
          <main>
            <transition-group class="users" tag="section" name="slide-fade">
              <div class="user" v-for="(user, idx) in server.Users" :key="idx">
                <div class="cell profile">
                  <span class="avatar">{{user.name.charAt(0).toUpperCase()}}</span>
                </div>
                <div class="cell info">
                  <span class="label">{{user.name}}</span>
                  <div class="email"><router-link to="/">{{user.email}}</router-link></div>
                </div>
                <div class="cell remove">
                  <button class="paper-action" @click="removeUser(user.email)"><heim-icon class="icon" icon="close"></heim-icon><span>{{ $t('remove') }}</span></button>
                </div>
                <div class="cell see">
                  <router-link class="paper-action" to=""><span>{{ $t('view') }}</span><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
                </div>
              </div>
              <div v-if="server.Users && !server.Users.length" class="empty-server-admin" key="empty">
                <div class="bg"></div>
                <span class="message">{{ $t('noUsersServer') }}</span>
              </div>
            </transition-group>
          </main>
        </heim-card>
      </div>
      <div class="select-user">
        <heim-card>
          <header>
            <h1>{{ $t('search') }} {{ $t('users') }}</h1>
          </header>
          <main>
            <div class="users">
              <div class="cell">
                <div class="custom-input">
                  <heim-input type="text" :label="$t('search') + ' ' + $t('user')" name="user" :placeholder="$t('placeholderUsername')" value="" :icon="true" v-model="search"></heim-input>
                  <heim-icon-button @click.native="e => {}">
                      <heim-icon class="icon" icon="search"></heim-icon>
                    </heim-icon-button>
                </div>
              </div>
            </div>
            <div class="users user-list">
              <div class="user" v-for="(user, idx) in filteredUsers" :key="'user-'+idx">
                <div class="cell profile">
                  <span class="avatar">{{user.name.charAt(0).toUpperCase()}}</span>
                </div>
                <div class="cell info">
                  <span class="label">{{user.name}}</span>
                  <div class="email"><router-link to="/">{{user.email}}</router-link></div>
                </div>
                <div class="cell see">
                  <button class="paper-action" @click="addUser(user.email)"><heim-icon class="add" icon="person-add"></heim-icon><span>{{ $t('add') }}</span></button>
                </div>
              </div>
            </div>
          </main>
        </heim-card>
      </div>
    </section>
    <heim-card class="danger-zone">
      <header>
        <h1>{{ $t('dangerZone') }}</h1>
      </header>
      <main>
        <div class="row">
          <div class="lab"><p>{{ $t('removeServer') }}</p>
            <p><strong>{{ $t('removingServer') }}</strong></p>
          </div>
          <div class="input">
            <button @click="deleteForm" class="paper-action remove"><heim-icon class="icon" icon="close"></heim-icon><span>{{ $t('remove') }}</span></button>
          </div>
        </div>
        <v-dialog/>
      </main>
    </heim-card>
  </section>
</template>

<script>
import Vue from "vue";
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimTextarea from "@/components/form/input/text/heim-textarea.vue";
import HeimToggleButton from "@/components/form/input/toggle/heim-toggle-button.vue";
import HeimSelect from "@/components/form/input/select/heim-select.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimIconButton from "@/components/form/button/heim-icon-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import HeimIcon from "@/components/icon/heim-icon.vue";
import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
import Places from "vue-places";

import VModal from "vue-js-modal";
Vue.use(VModal, { dialog: true });

export default {
  name: "ServersEdit",
  components: {
    HeimInput,
    HeimTextarea,
    HeimToggleButton,
    HeimSelect,
    HeimButton,
    HeimIconButton,
    HeimCard,
    HeimIcon,
    Datepicker,
    Places
  },
  data() {
    return {
      form: {
        country: {
          label: null,
          data: {}
        }
      },
      search: ""
    };
  },
  mounted() {
    this.$store.dispatch("getProviders");
    this.$store.dispatch("getUsers");
    const id = this.$route.params.id;
    this.$store.dispatch("getServer", id);

    this.$watch(
      vm => vm.server,
      val => {
        this.$store.dispatch("setTitle", `Edit server - ${val.name}`);
      }
    );
  },
  computed: {
    ...mapState({ users: state => state.usersState.users }),
    ...mapState({ server: state => state.serversState.server }),
    ...mapState({ providers: state => state.serversState.providers }),
    filteredUsers() {
      if (!this.server.Users) return [];
      // Check if the user if not already in the site administrator user array
      const filteredUsers = this.users.filter(
        user => this.server.Users.map(user => user.id).indexOf(user.id) == -1
      );

      return filteredUsers.filter(user => {
        return user.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  methods: {
    async handleForm() {
      const data = await this.$store.dispatch("updateServer", {
        id: this.server.id,
        server: {
          name: this.server.name,
          ip: this.server.ip,
          description: this.server.description,
          cpu_threshold: this.server.cpu_threshold,
          cpu_alert: this.server.cpu_alert,
          mem_threshold: this.server.mem_threshold,
          mem_alert: this.server.mem_alert,
          drive_threshold: this.server.drive_threshold,
          drive_alert: this.server.drive_alert,
          interval: this.server.interval,
          nb_occurence: this.server.nb_occurence,
          provider_id: this.server.provider_id,
          cost_server: this.server.cost_server,
          cost_hard_disk: this.server.cost_hard_disk,
          auxiliary_cost: this.server.auxiliary_cost,
          type_server: this.server.type_server,
          nb_cpu: this.server.nb_cpu,
          nb_ram: this.server.nb_ram,
          disk_space: this.server.disk_space,
          enabled: this.server.enabled,
          hosting_reserved: this.server.hosting_reserved,
          hosting_birthday: this.server.hosting_birthday,
          hosting_localization: this.server.hosting_localization,
          rds: this.server.rds,
          backup: this.server.backup,
          bandwidth: this.server.bandwidth,
          support: this.server.support,
          ip_elastic: this.server.ip_elastic
        }
      });

      this.$validator.validateAll().then(result => {
        if (result && data.id) {
          this.$store.dispatch("setToastMessage", {
            message: "updateSuccessful"
          });
          this.$store.dispatch("setToastMode", {});
          this.$store.dispatch("setOpenToast", { opened: true });
          this.$router.push({ path: `/servers/${this.server.id}/details` });
        }
      });
    },
    async removeServer() {
      const data = await this.$store.dispatch("deleteServer", {
        id: this.server.id
      });
      if (data.success) {
        this.$store.dispatch("setToastMessage", {
          message: "deleteSuccessful"
        });
        this.$store.dispatch("setToastMode", {});
        this.$store.dispatch("setOpenToast", { opened: true });
        this.$router.push({ path: `/servers` });
      }
    },
    addUser(email) {
      const data = this.$store.dispatch("addUserToServer", {
        id: this.server.id,
        email
      });
      if (data.id) {
        this.$store.dispatch("setToastMessage", {
          message: "updateSuccessful"
        });
        this.$store.dispatch("setToastMode", {});
        this.$store.dispatch("setOpenToast", { opened: true });
      }
    },
    removeUser(email) {
      const data = this.$store.dispatch("removeUserFromServer", {
        id: this.server.id,
        email
      });
      if (data.id) {
        this.$store.dispatch("setToastMessage", {
          message: "updateSuccessful"
        });
        this.$store.dispatch("setToastMode", {});
        this.$store.dispatch("setOpenToast", { opened: true });
      }
    },
    deleteForm() {
      this.$modal.show("dialog", {
        title: "Suppression",
        text: "Etes-vous sur de vouloir supprimer ce serveur ?",
        buttons: [
          {
            title: "Oui",
            handler: () => {
              this.removeServer();
            }
          },
          {
            title: "Non",
            default: true
          }
        ]
      });
    }
  }
};
</script>

<style>
input.paper-input,
.ap-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
}

input.paper-input:hover,
input.paper-input:focus,
.ap-input:hover,
.ap-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}
</style>

<style scoped>
.empty-server-admin {
  display: flex;
  flex-direction: column;
  height: 15em;
}
.empty-server-admin .bg {
  background-image: url("/img/undraw_add_user_ipe3.svg");
  background-size: 100% 100%;
  background-position: center;
  height: 100%;
  margin-bottom: 1em;
}
.empty-server-admin .message {
  justify-content: center;
  display: block;
  text-align: center;
}

.paper-card {
  margin-bottom: 1.5em;
}

.site-endpoints {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0.8em 1em;
  border-bottom: 1px solid #eeeeee;
}

.endpoint-url {
  width: 100%;
}

.integrity-key {
  width: 100%;
}

.site-endpoints .endpoint-action-button {
  display: flex;
  align-items: center;
  margin-right: 1em;
}

.site-endpoints .endpoint-action-button .update .icon {
  margin: 0 0.5em;
}

.site-endpoints .endpoint-action-button .remove {
  color: var(--heim-red-color);
  border-color: var(--heim-red-color);
}

.user-section {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
}

.server-users,
.select-user {
  width: 100%;
}

.select-user .user-list {
  height: 16em;
  overflow-y: auto;
}

.select-user .custom-input {
  position: relative;
  width: 100%;
}

.select-user .custom-input .icon-button {
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 4px;
}

.users {
  width: 100%;
  padding: 0.6rem 1rem;
}

.users .user {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 8px;
}
.users .user:hover {
  background-color: var(--heim-grey-color);
}

.users .cell {
  padding: 0.3rem 0.5rem;
}

.users .user .info {
  flex: 1;
}

.users .user .info .email {
  font-size: 0.8rem;
  font-weight: 600;
  word-break: break-word;
}

.users .user .profile {
  display: none;
}

.users .user .avatar {
  font-size: 1.5rem;
  font-weight: 600;
  background-color: var(--heim-secondary-color);
  color: var(--heim-white-color);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  border: solid thin var(--heim-grey-color);
  cursor: default;
}

.users .remove .paper-action {
  color: var(--heim-red-color);
  border-color: var(--heim-red-color);
}

.users .user .info .label {
  font-size: 1.2em;
  font-weight: 400;
}

.danger-zone {
  border-top: solid 4px var(--heim-red-color);
}

.danger-zone h1 {
  color: var(--heim-red-color);
}

.danger-zone .remove {
  color: var(--heim-red-color);
  border-color: var(--heim-red-color);
}

.label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}

.heim-input {
  max-width: 32em;
}

.heim-input input {
  width: 100%;
}

.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}

/* Wide layout: when the viewport width is bigger than 460px, layout
  changes to a wide layout. */
@media (min-width: 460px) {
  .ctn {
    margin: 1em 10em 0 10em;
  }

  .server-users {
    margin-right: 1em;
  }

  .server-users {
    width: 58%;
  }
  .select-user {
    width: 40%;
  }

  .users .user .profile {
    display: block;
  }

  .select-user .custom-input {
    width: 60%;
  }
}
</style>
